import { useWizard } from "react-use-wizard";
import { IFillDataWizardSell, TKeyOfDataWizardSell } from "../..";
import FeaturesFacilityStep, {
  IDataFeatures,
} from "../../../../../../shared/wizard/steps/featuresStep";
import sellSteps from "../sellSteps";

interface IKnowPriceStep_9 {
  onChange: (data: Partial<IFillDataWizardSell>) => void;
  data: Partial<IFillDataWizardSell>;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const KnowPriceStep_9= ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IKnowPriceStep_9) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.knowPrice.step_8);
    onReset([
      "debt",
      "arrest",
      "encumbrance",
      "childrenOwn",
      "privatization",
    ]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.knowPrice.step_10);
  };

  return (
    <div>
      <FeaturesFacilityStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data as IDataFeatures}
      />
    </div>
  );
};

export default KnowPriceStep_9;
